import h from '../utils/htm';
import domWrap from '../utils/domWrap';
import scrollNav from '../utils/scrollNav';

export default async explorer => {
	const header = explorer.querySelector('header');
	let hasImage = false;
	const 	slides = [...explorer.querySelectorAll('comp-list')].map((copyGroup,index) => {
		const image = copyGroup.getAttribute('image');
		const imgAlt = copyGroup.getAttribute('imgAlt');		
		copyGroup.setAttribute('index', index);
		if (image) {
			hasImage = true;
			return h(`div class="slide" index="${index}" style="background-image: url(${image})" role="img" aria-label="[${imgAlt}]"`,
				// Point
				h('div',
					h('div',
						h('div')('div')('div')('div')
					)
				)
			).Node
		}
		else {
			return h(`div class="slide empty" index="${index}"`).Node;
		}
	}).filter(Boolean),
	navigation = domWrap(explorer.querySelector('nav'));

	slides.forEach(function (slide) { 
		this.appendChild(slide);
	}, header);

	if (!hasImage)
		header.classList.add('empty');

	[...explorer.querySelectorAll('comp-list > div')].forEach( (copyContainer, index) => {
		navigation.appendChild(
			domWrap(
				h(`button class="text"`,( copyContainer.getAttribute('tab') || copyContainer.querySelector('h2')?.textContent )).Node
			)
			.data('coords',copyContainer.getAttribute('coord')?.split(',') || [])
			.data('copyContainer', domWrap(copyContainer))
			.data('slide', domWrap(explorer.querySelector(`.slide[index="${copyContainer.parentNode.getAttribute('index')}"]`)))
		);
	});

	scrollNav(navigation);
	navigation.on('click','button',buttonClick);
	buttonClick.call(navigation.querySelector('button'));
	explorer.classList.add('loaded');

	function buttonClick() {
		var button = domWrap(this),
			copyContainer = button.data('copyContainer'),
			slide = button.data('slide'),
			coords = button.data('coords');

		button.setSelected();
		copyContainer.setSelected();
		domWrap(copyContainer.parentNode).setSelected();

		setSlide(slide,() => {
			if(coords.length === 2){
				[...slide.children].forEach(child => domWrap(child).css({
					left: coords[0] + '%', 
					top: coords[1] + '%'
				}).classList.add('active'));
			}
		});
	}
};	

function setSlide(slide,done, timer = setTimeout(() => {}, 0)){
	const slides = [...slide.parentNode.children],
		current = slides.indexOf(slide.parentNode.querySelector('.selected')),
		target = slides.indexOf(slide),
		length = slides.length,
		increment = current > target ? 
			length - current + target <= current - target : 
			target - current <= length - target + current,
		next = increment ?
			current + 1 === length ? 0 : current + 1 :
			current > 0 ? current - 1 : length - 1;

	clearTimeout(timer);
	
	if(current === -1 || current === target){
		slide.setSelected();
		done();
		return;
	}
	domWrap(slides[next]).setSelected();
	timer = setTimeout(() => setSlide(slide,done,timer), 1000 / length);
}